import React from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faRocket, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import './ComingSoonModal.css';

const ComingSoonModal = ({ isOpen, onClose, featureName }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  const openRoadmap = () => {
    onClose();
    navigate('/roadmap');
  };

  return createPortal(
    (
    <div className="coming-soon-modal-overlay" onClick={onClose}>
      <div className="coming-soon-modal" onClick={(e) => e.stopPropagation()}>
        <button className="coming-soon-modal-close" onClick={onClose}>
          <FontAwesomeIcon icon={faTimes} />
        </button>
        <div className="coming-soon-modal-content">
          <div className="coming-soon-modal-badge">
            <FontAwesomeIcon icon={faRocket} />
            <span>In the works</span>
          </div>
          <h2 className="coming-soon-modal-title">Coming Soon</h2>
          <p className="coming-soon-modal-message">
            {featureName
              ? <><strong>{featureName}</strong> is under active development. Preview where it sits in our roadmap and what's landing next.</>
              : "This feature is under active development. Preview where it sits in our roadmap and what's landing next."}
          </p>
          <button className="coming-soon-modal-cta" onClick={openRoadmap}>
            <span>Check out our roadmap</span>
            <FontAwesomeIcon icon={faArrowRight} />
          </button>
          <button className="coming-soon-modal-secondary" onClick={onClose}>
            Maybe later
          </button>
        </div>
      </div>
    </div>
    ),
    document.body
  );
};

export default ComingSoonModal;
